import { HiveResult } from "../types";
import useRequest, { Fetch, RequestResult } from "./useRequest";

export default function useHive(
  id: number,
  params?: Record<string, unknown>,
): [RequestResult<HiveResult>, Fetch] {
  return useRequest<HiveResult, any>(`/hive/${id}/`, params);
}
